{
  "handicap_recommendations": {
    "title": "Handicap Recommendations",
    "add_new": "Add New",
    "edit": "Edit Recommendation",
    "all_types": "All Play Types",
    "percentages_help": "Enter percentages separated by commas, e.g. 30,20,10",
    "table": {
      "play_type": "Play Type",
      "team_size": "Team Size",
      "counting_scores": "Counting Scores",
      "handicap_factor": "Handicap Factor",
      "team_percentages": "Team Handicap Percentages",
      "description": "Description",
      "source": "Source",
      "status": "Status",
      "men_max": "Men Max",
      "women_max": "Women Max"
    },
    "no_recommendations": "No handicap recommendations."
  },
  "search_users": "Search users...",
  "no_users_found": "No users found",
  "users_table": {
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "tenant": "Club",
    "created": "Created",
    "icons": {
      "course_conditions": "User has rounds with saved course conditions",
      "friends": "User has friends",
      "statistics": "User has rounds with saved statistics"
    },
    "user": "User"
  },
  "create_user": "Create user",
  "create_user_page": {
    "title": "Create new user",
    "section_account": "Account details",
    "section_personal": "Personal details",
    "section_golf": "Golf details",
    "email": "Email",
    "password": "Password",
    "first_name": "First name",
    "last_name": "Last name",
    "gender": "Gender",
    "date_of_birth": "Date of birth",
    "handicap_index": "Handicap",
    "role": "Role",
    "tenant": "Customer",
    "no_tenant": "No customer",
    "submit": "Create user",
    "success": "User created successfully",
    "error": "Failed to create user",
    "password_requirements": "At least 8 characters, including uppercase, lowercase and a number",
    "email_taken": "Email address is already in use",
    "email_required": "Email is required",
    "email_invalid": "Invalid email address",
    "first_name_required": "First name is required",
    "last_name_required": "Last name is required",
    "username": "Username"
  },
  "edit_user_page": {
    "save": "Save",
    "delete": "Delete",
    "delete_confirm_title": "Delete user",
    "delete_confirm_message": "Are you sure you want to delete user {{name}}?",
    "password_hint": "Leave blank if you don't want to change it",
    "success": "User updated",
    "deleted": "User deleted",
    "not_found": "User not found",
    "refresh_handicap": "Refresh from eBirdie",
    "refresh_handicap_updated": "Handicap updated: {{value}}",
    "refresh_handicap_unchanged": "Handicap is already up to date",
    "refresh_handicap_null": "No handicap received from eBirdie",
    "refresh_handicap_failed": "Failed to fetch handicap from eBirdie",
    "refresh_handicap_not_linked": "User does not have a linked SuomiGolf account",
    "results_table": {
      "title": "Played Rounds",
      "when": "Played",
      "where": "Course",
      "tee": "Tee",
      "type": "Type",
      "status": "Status",
      "ebirdie_status": "eBirdie",
      "resend": "Resend",
      "resend_success": "Resend initiated",
      "resend_failed": "Resend failed",
      "confirm_resend_title": "Resend to eBirdie",
      "confirm_resend_body": "Resend the round played on {{date}} at {{course}} to eBirdie?",
      "no_results": "No played rounds",
      "type_competition": "Competition round",
      "type_handicap": "Handicap round",
      "type_round": "Practice round",
      "status_completed": "Completed",
      "status_in_progress": "In progress",
      "status_abandoned": "Abandoned",
      "status_disqualified": "Disqualified",
      "ebirdie_status_completed": "Sent",
      "ebirdie_status_queued": "Queued",
      "ebirdie_status_failed": "Error",
      "ebirdie_status_permanent_failure": "Permanent failure"
    },
    "email_hint": "The change takes effect immediately without a confirmation message",
    "registration_method": "Registration method",
    "registration_time": "Registration time",
    "section_account": "Account Details",
    "section_personal": "Personal Information",
    "section_golf": "Role",
    "registered": "Registered",
    "time": "Time",
    "ebirdie_linked": "eBirdie Linked",
    "hcp": "HCP",
    "customer": "Customer (club)",
    "tabs": {
      "basic": "Basic Info",
      "rounds": "Played Rounds"
    }
  },
  "users_page": {
    "refresh_all_handicaps": "Refresh handicaps",
    "refresh_all_summary": "Updated {{updated}}/{{scanned}} (unchanged {{unchanged}}, empty {{nullFromEbirdie}}, error {{failed}})"
  }
}
